import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import { Avatar } from "@answersnow/pkg-theme";
import Typography from "@mui/material/Typography";
import { DialogTitle, Stack } from "@mui/material";

const AssignClinicianConfirmDialog = (props) => {
  const { open, closeDialog, assignedRole, submitAssignClinician, selectedClinician, confirmSent } =
    props;
  const assignmentType = assignedRole === "primary" ? "Clinician" : "Supervisor";
  return (
    <Dialog
      open={open}
      onClose={closeDialog}
      aria-labelledby="switch-clinician-dialog"
      key="switch-clinician-dialog"
    >
      <DialogTitle>Confirm {assignmentType} Assignment</DialogTitle>
      <DialogContent>
        <Stack direction="row" gap={5} alignItems="center">
          <Avatar imageUrl={selectedClinician.image_url} />
          <Stack>
            <Typography component="p" variant="body1">
              You have selected {selectedClinician.name} to be the {assignmentType}.
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={submitAssignClinician} color="primary" disabled={confirmSent}>
          Confirm
        </Button>
        <Button onClick={closeDialog} color="secondary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssignClinicianConfirmDialog;
